import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const aboutImage = 'https://customer-assets.emergentagent.com/job_vic-storage-depot/artifacts/lfi7u4di_WGH%20Headquarters.jpg';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="bg-[#1a1a1a] py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">About Wycheproof Grain Handling</h1>
            <p className="text-gray-300 max-w-2xl mx-auto">
              Your trusted partner for grain storage and export solutions in regional Victoria.
            </p>
          </div>
        </section>

        {/* Our Story Section */}
        <section className="py-16">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
              <div>
                <img
                  src={aboutImage}
                  alt="Wycheproof Grain Handling headquarters"
                  className="rounded-lg shadow-lg w-full h-80 object-cover"
                />
              </div>
              <div className="space-y-6">
                <h2 className="text-3xl font-bold text-gray-900">Our Story</h2>
                <p className="text-gray-700 leading-relaxed">
                  Building on the proud legacy of the Wycheproof Grain Company, <strong>Wycheproof Grain Handling Pty Ltd</strong> now continues to serve Victoria's farming community with professional grain storage and handling services. Located in the heart of Wycheproof, we remain dedicated to supporting local growers and understanding the unique challenges and needs of our region's grain industry.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Our new modern facilities are purpose-built to provide secure, high-quality storage solutions for your valuable grain harvest. Designed with efficiency and safety in mind, our sites ensure that every tonne is handled with the utmost care — protecting grain quality from the moment it arrives to the moment it leaves.
                </p>
              </div>
            </div>

            <div className="mt-12 space-y-6">
              <p className="text-gray-700 leading-relaxed">
                Over the years, we've built our reputation on reliability, integrity, and a genuine commitment to supporting local agriculture. Every service we offer is backed by a deep understanding of the seasonal pressures, market demands, and hard work that define farming in our region. Our goal is simple — to give growers confidence that their grain is in the best possible hands.
              </p>
              <p className="text-gray-700 leading-relaxed">
                In addition to our storage operations, we proudly operate a professional container packing facility. This modern site enables efficient and compliant export preparation, giving growers direct access to international markets. From paddock to port, our experienced team ensures a seamless process — helping local producers expand their reach, improve logistics, and achieve the best returns for their grain.
              </p>
            </div>
          </div>
        </section>

        {/* What Sets Us Apart */}
        <section className="py-16 bg-[#faf8f5]">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center">What Sets Us Apart</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                'Commitment to quality and service excellence',
                'Modern storage facilities with advanced technology',
                'Experienced team dedicated to grower success',
                'Strong relationships with the farming community',
                'Reliable and professional container packing',
                "Strategic location in Victoria's grain belt"
              ].map((item, index) => (
                <div key={index} className="flex items-start gap-3 p-4 bg-white rounded-lg">
                  <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0" />
                  <p className="text-gray-700">{item}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Our Commitment */}
        <section className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Commitment to You</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              At Wycheproof Grain Handling, we're more than just a storage facility – we're your partners in success. We understand that your grain represents months of hard work, significant investment, and your livelihood.
            </p>
            <p className="text-gray-700 leading-relaxed">
              That's why we maintain the highest standards in grain storage, handling, and export services. Our experienced team is always ready to provide the support and expertise you need, when you need it.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
